// @flow

// force flow to type check this file - https://github.com/zapier/zapier/pull/31127
import React /* eslint-disable-line no-unused-vars */, {
  Fragment,
} from 'react';

import {
  Button,
  Colors,
  Heading,
  Img,
  Margin,
  Spacer,
  Text,
  Typography,
} from '@zapier/design-system';
import { isolateComponent, labelStyles } from '@zapier/common-utils';

import { type Size } from '@zapier/design-system-company';

/** @jsx isolateComponent */

type Props = {
  /** Callback to be executed when the button is clicked */
  onButtonClick: (e: SyntheticMouseEvent<*>) => void,
  /** Size */
  size: Size,
};

const Styles = labelStyles(__filename, {
  buttonWrapper: {
    textAlign: 'center',
  },
  heading: {
    ...Typography.subtitle900,
    color: Colors.grey900,
    textAlign: 'center',
  },
});

const TrialWelcomeModalDefaultView = (props: Props) => {
  return (
    <Fragment>
      <Img
        alt="Zaplings celebrating with confetti"
        src="https://cdn.zapier.com/storage/photos/f68afd624b52986660770f843ea51a0c.png"
      />

      <Margin margin="25px 40px 40px 40px">
        <Heading css={Styles.heading}>
          Welcome to your trial of
          <br />
          Zapier for Companies
        </Heading>

        <Spacer height={25} />

        <Text color="grey900" tag="p" textAlign="center" type="bodyText900">
          Collaborate and organize your team's workflows with advanced
          administrative and security controls.
        </Text>

        <Spacer height={40} />

        <div css={Styles.buttonWrapper}>
          <Button
            casing="uppercase"
            hasShadow={true}
            isFullWidth={props.size === 'small'}
            onClick={props.onButtonClick}
          >
            Open Guide
          </Button>
        </div>
      </Margin>
    </Fragment>
  );
};

export default TrialWelcomeModalDefaultView;
